import React from "react";
import TreasuryCoordinatorTransactionDetails from "../../TreasuryCoordinator/TreasuryCoordinatorTransactionDetails.js";
function ClearnaceCoordinatorTransactionDetails() {
  return (
    <TreasuryCoordinatorTransactionDetails
     isEdit={false}
    />
  );
}

export default ClearnaceCoordinatorTransactionDetails;
